module.exports = __webpack_public_path__ + "media/images/icon_address-4419f6489c913fc975fbc2f258343a2d.png";